module.exports = __webpack_public_path__ + "static/media/logo.7f6486c7.svg";